<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">

    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">

      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-rule">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter une Règle de contrôle
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>

      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher par code, libellé ou sévérité..." />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th>Code</th>
              <th>Libellé</th>
              <th>Description</th>
              <th>Entité ciblée</th>
              <th>Sévérité</th>
              <th>Active</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in rules" :key="i">
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td class="text-truncate" style="max-width: 200px">
                {{ item.description }}
              </td>
              <td>{{ item.target_entity_type }}</td>
              <td>{{ item.severity }}</td>
              <td>
                <span class="badge" :class="item.is_enabled ? 'bg-success' : 'bg-danger'">
                  {{ item.is_enabled ? 'Oui' : 'Non' }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{ name: 'EditRulePage', params: { id: item.id } }"
                        class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                    </li>

                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="deleteRule(item.id)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-area d-md-flex mt-15 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "../../services/ApiService";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import { suppression, error } from "../../utils/utils";
import { Rule } from "@/models/Rule";
import JwtService from "@/services/JwtService";
import Swal from "sweetalert2";


export default defineComponent({
  name: "ListeRule",
  components: {
    PaginationComponent
  },
  setup() {

    onMounted(() => {
      getAllRules();
    });

    const rules = ref<Array<Rule>>([]);
    const rule = ref<Rule>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllRules(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      getAllRules(page.value, limit.value, searchTerm.value);
    }

    // END PAGINATE



    function getAllRules(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/rules??page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log("Aaaronnnndonnnne", data);
          rules.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          console.log("NOS ERREURS", response);
          // error(response.data.message)
        });
    }

    function moddifier(Editrules: Rule) {
      rule.value = Editrules;
    }

    // const deleteRule = (id: string) => {
    //   ApiService.delete(`/rule/${id}`)
    //   .then(({ data }) => {
    //     Swal.fire({
    //       text: data.message,
    //       toast: true,
    //       icon: 'success',
    //       title: 'General Title',
    //       animation: false,
    //       position: 'top-right',
    //       showConfirmButton: false,
    //       timer: 5000,
    //       timerProgressBar: true,
    //       heightAuto: false
    //     });
    //   })
    //   .catch(({ response }) => {
    //     Swal.fire({
    //       text: response.data.message,
    //       icon: "error",
    //       buttonsStyling: false,
    //       confirmButtonText: "Réssayer à nouveau!",
    //       heightAuto: false,
    //       customClass: {
    //         confirmButton: "btn fw-semobold btn-light-danger",
    //       },
    //     });
    //   });

    //   for(let i = 0; i < rules.value.length; i++) {
    //     if (rules.value[i].id === id) {
    //       rules.value.splice(i, 1);
    //     }
    //   }
    // };

    const deleteRule = (id: string) => {
      Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: 'Voulez-vous vraiment effectuer cette suppression ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.delete(`/rule/${id}`)
            .then(({ data }) => {
              Swal.fire({
                text: data.message,
                toast: true,
                icon: 'success',
                title: 'General Title',
                animation: false,
                position: 'top-right',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                heightAuto: false
              });
            })
            .catch(({ response }) => {
              Swal.fire({
                text: response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Réssayer à nouveau!",
                heightAuto: false,
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });

          for (let i = 0; i < rules.value.length; i++) {
            if (rules.value[i].id === id) {
              rules.value.splice(i, 1);
            }
          }
        }
      });
    };
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      rules,
      checkPermission,
      getAllRules,
      deleteRule,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm
    };

  },
});
</script>
